/**
 * Enum for different types of tasks that a Sleeve can perform
 */
export enum SleeveTaskType {
  // Same Order as selectable order in UI
  Idle,
  Company,
  Faction,
  Crime,
  Class,
  Gym,
  Bladeburner,
  Recovery,
  Synchro,
}
